import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/transporte",
    label: "Transporte",
    isActive: true,
  },
];

function Transporte() {
  return (
    <Page
      title="Transporte"
      description="Planeación y control de transporte mascotas agendadas."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Transporte;
